import { type RefObject, useLayoutEffect, useRef } from 'react';

export const useReturnFocusOnHide = (
  isHidden: boolean,
  panelRef: RefObject<HTMLElement | null>
): void => {
  const returnFocusTo = useRef<HTMLElement | null>(null);

  useLayoutEffect(() => {
    if (!isHidden) {
      returnFocusTo.current =
        document.activeElement instanceof HTMLElement
          ? document.activeElement
          : null;
      return;
    }
    const target = returnFocusTo.current;
    returnFocusTo.current = null;
    if (
      target?.isConnected &&
      panelRef.current?.contains(document.activeElement) &&
      !panelRef.current.contains(target)
    ) {
      target.focus();
    }
  }, [isHidden, panelRef]);
};
